/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { format } from "date-fns";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string | null;
  tipoSerie: string | null;
  frequencia: string | null;
  qtdParcelas: string | null;
  valorParcela: string;
  dtVencimento: any;
  juros: boolean;
  fixo: boolean;
  idLeadCorretor: any;
  idOportunidade?: any;
}

export function useInserirItem(props: Props) {
  function convertToNumber(brNumber: string): number {
    const numberWithoutDots = brNumber.replace(/\./g, "");
    const numberWithDot = numberWithoutDots.replace(",", ".");
    return parseFloat(numberWithDot);
  }
  const postData = async () => {
    const INSERIR_ITEM = `${backofficeEnviroment}/common/oportunidades-lead/criar-nova-serie/v1`;
    const { data } = await instance.put(INSERIR_ITEM, {
      idUnidade: props.idUnidade,
      tipoSerie: Number(props.tipoSerie),
      frequencia: Number(props.frequencia),
      qtdParcelas: Number(props.qtdParcelas),
      valorParcela: convertToNumber(props.valorParcela),
      dtVencimento: format(props.dtVencimento, "yyyy-MM-dd"),
      juros: props.juros,
      fixo: props.fixo,
      idLeadCorretor: props.idLeadCorretor,
      idOportunidade: props.idOportunidade,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Item inserido com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao inserir item. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
